import React, {useContext, useEffect} from "react";
import {UserContext} from "@context/UserContext";
import {BrandContext} from "@context/BrandContext";
import {ContentContext} from "@context/ContentContext";
import {MenuCompressButton} from "./CompressButton";
import ShortcutLink from "@common/ShortcutLink";
import ListItem from "@common/ListItem";
import {UserIcon} from "@common/icons";
import {PageMarkerNavigation} from "./PageMarkerNavigation";
import {TemplateContext} from "@common/context/TemplateContext";
import {useScreenMode} from "@common/context/ScreenModeContext";

const NavigationRight = props => {
    const {compressed, callback, children} = props;
    const {user, updateRightMenuClosed} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {bodyComponentName} = useContext(TemplateContext);
    const {smallScreenMode} = useScreenMode();

    useEffect(() => {
        if(user.publicSession || user.expired) {
            return;
        }

        if (!compressed && smallScreenMode) {
            updateRightMenuClosed(true);
        } else if (brandConfig.rightMenuOpen) {
            updateRightMenuClosed(false);
        }
    }, [smallScreenMode]);

    const shouldShowMenuCompressButton = (
        (!smallScreenMode && !brandConfig.useDevelopmentNavigation) ||
        (brandConfig.useDevelopmentNavigation && bodyComponentName === 'LessonContentStyleGuide') ||
        user.cmsMode
    );

    if(user.publicSession && user.guideMode) {
        return <div className={'ch-nav-right ' + (compressed  ? ' compressed' : '')}>
            <div className={'ch-nav-r-inner'}>
                <div className="ch-nav-shortcuts-head" style={{display: 'none'}}>
                </div>
                <div className="ch-nav-shortcuts-body">
                    <PageMarkerNavigation/>
                </div>
            </div>
        </div>;
    } else if (user.publicSession || user.expired) {
        return null;
    }

    return (
        <>
            {shouldShowMenuCompressButton && (
                <MenuCompressButton hidden={brandConfig.rightMenuOpen} right={!compressed} onClick={callback} />
            )}
            <div className={'ch-nav-right ' + (compressed  ? ' compressed' : '')}>
                <div className={'ch-nav-r-inner'}>
                    {!brandConfig.useDevelopmentNavigation &&
                        <div className="ch-nav-shortcuts-head">
                            <ul className="ch-list" style={{width: '100%'}}>
                                <ListItem>
                                    <ShortcutLink shortcutUrl="/controlCentre/showUserDetails.action" style={{width: '100%'}}>
                                        <span className={'flexAlignCentre'}>
                                            <UserIcon width={20} style={{marginRight: '8px'}} /><span className={'ch-nav-shortcuts-head-user'}>{user.firstName}</span>
                                        </span>
                                    </ShortcutLink>
                                </ListItem>
                            </ul>
                        </div>
                    }
                    <div className="ch-nav-shortcuts-body">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
}

export default NavigationRight;